module.exports = __webpack_public_path__ + "img/logo.6f3ce872.png";